import MbmNotifyMeModal from '@moncler/components/mbm/MbmNotifyMeModal';
import ProductNotifyMeModal from '@moncler/components/product/ProductNotifyMeModal';
import Button from '@ui/button/Button';
import analytics from '@utils/analytics';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import whatInput from 'what-input';
const WishlistActionNotifyMe = (props) => {
    var _a, _b;
    const { t } = useTranslation();
    const [showOverlay, setShowOverlay] = React.useState(false);
    const [showSizeBtn, setShowSizeBtn] = useState(false);
    let btnClass = props.buttonStyleSecondary ? 'button--secondary' : 'button--primary';
    if (props.buttonStyleInverted) {
        btnClass += '-inverted';
    }
    const classes = [btnClass];
    const onOpenModal = () => {
        if (!props.size) {
            console.log('no size, triggering size selector:', props.triggerOpenSize);
            setShowSizeBtn(true);
            props.triggerOpenSize && props.triggerOpenSize();
            return;
        }
        setShowOverlay(true);
        props.onOpenModal && props.onOpenModal();
        // analytics.notifyMe(props.product.masterId, props.from);
        analytics.wishlistInteractionNotify(props.product.masterId);
    };
    const onCloseModal = (triggerCloseOnly) => {
        setShowOverlay(false);
        typeof triggerCloseOnly != 'boolean' && props.onCloseModal && props.onCloseModal();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "wishlist__single-product__notify-btn", onMouseEnter: () => {
                whatInput.ask() === 'mouse' && !props.size && setShowSizeBtn(true);
            }, onMouseLeave: () => {
                whatInput.ask() === 'mouse' && setShowSizeBtn(false);
            } },
            React.createElement(Button, { type: "button", cls: props.customClasses ? props.customClasses : classes, onClick: () => {
                    onOpenModal();
                }, ariaHaspopup: "dialog" }, showSizeBtn ? t('label.selectasize') : t('label.notifyme')),
            ((_a = props.product) === null || _a === void 0 ? void 0 : _a.isMbm) ? (React.createElement(MbmNotifyMeModal, { isOpen: showOverlay, onRequestClose: onCloseModal, imgs: props.product.imgs, editLink: (_b = props.product.mbm) === null || _b === void 0 ? void 0 : _b.editurl })) : (React.createElement(ProductNotifyMeModal, { isOpen: showOverlay, title: t('label.notifyme'), product: props.product, color: props.color, size: props.size, onRequestClose: onCloseModal, from: props.from, fromReserve: props.fromReserve, inWishlist: true })))));
};
export default WishlistActionNotifyMe;
